import * as React from 'react';
import { Form } from './Form';
import { Buttons } from './Buttons';
import { Disclaimer } from './Disclaimer';

interface StringMap {
  [s: string]: string;
}

interface FormLayoutProps {
  showSuccsessMessage(b: boolean): void;
  onCancelClick(): void;
  formInputLabels: StringMap;
  disclaimerKey: string;
  hideCancel?: boolean;
  labelSize?: string;
  inputSize?: string;
}

export const FormLayout: React.FC<FormLayoutProps> = ({
  showSuccsessMessage,
  onCancelClick,
  formInputLabels,
  hideCancel = false,
  labelSize,
  inputSize,
  disclaimerKey,
}) => {
  const {
    firstName,
    lastName,
    bussinessEmail,
    phoneNumber,
    company,
    jobTitle,
    messageBox,
  } = formInputLabels;
  return (
    <Form onSubmitSuccess={showSuccsessMessage}>
      <Form.Input
        name='firstName'
        label={firstName}
        labelSize={labelSize}
        inputSize={inputSize}
        isRequired
      />
      <Form.Input
        name='lastName'
        label={lastName}
        labelSize={labelSize}
        inputSize={inputSize}
        isRequired
      />
      <Form.Input
        name='bussinessEmail'
        label={bussinessEmail}
        labelSize={labelSize}
        inputSize={inputSize}
        isRequired
      />
      <Form.Input
        name='phoneNumber'
        label={phoneNumber}
        labelSize={labelSize}
        inputSize={inputSize}
        isRequired
      />
      <Form.Input
        name='company'
        label={company}
        labelSize={labelSize}
        inputSize={inputSize}
      />
      <Form.Input
        name='jobTitle'
        label={jobTitle}
        labelSize={labelSize}
        inputSize={inputSize}
      />
      <Form.InputArea
        name='messageBox'
        label={messageBox}
        labelSize={labelSize}
        inputSize={inputSize}
      />
      <Disclaimer disclaimerKey={disclaimerKey} />
      <Buttons>
        {!hideCancel && <Buttons.Cancel onCancel={onCancelClick} />}
        <Buttons.Submit />
      </Buttons>
    </Form>
  );
};
